<template>
  <ValidationObserver
    v-slot="{handleSubmit}"
    ref="formObserver"
  >
    <b-modal
      id="measuresModal"
      v-model="measuresModal.show"
      title="Create Measure"
      @hidden="hideMeasuresModal"
      @ok.prevent="handleSubmit(onSubmit)"
      @hide="beforeHide"
    >
      <content-spinner
        :show="measuresModal.loading"
        text="Please wait..."
      />
      <b-form
        @submit="handleSubmit(onSubmit)"
        @reset="handleSubmit(onReset)"
      >
        <input-widget
          ref="focusedField"
          :model="form"
          :field="fields.name"
          :autofocus="true"
        />
        <input-widget
          :model="form"
          :field="fields.notes"
        />
        <!--        <input-widget :model="form" :field="fields.tags"/>-->
        <input-widget
          :model="form"
          :field="fields.minorElement"
        />


        <b-button
          v-if="!expand"
          type="button"
          size="md"
          variant="primary"
          class="expand-button"
          @click="expand = true"
        >
          Show Advanced Options
        </b-button>

        <div v-if="expand">
          <input-widget
            :model="form"
            :field="fields.includeOnPhysical"
          />
          <input-widget
            :model="form"
            :field="fields.includeOnLogical"
          />
          <input-widget
            :model="form"
            :field="fields.dataType"
          />
          <input-widget
            :model="form"
            :field="fields.numericPrecision"
          />
          <input-widget
            :model="form"
            :field="fields.numericScale"
          />
          <input-widget
            :model="form"
            :field="fields.defaultValue"
          />
          <input-widget
            :model="form"
            :field="fields.aggregationType"
          />
        </div>
      </b-form>
      <template #modal-footer="{ok, cancel}">
        <modal-footer
          v-model="addAnother"
          :loading="measuresModal.loading"
          :cancel="cancel"
          :ok="ok"
        />
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../core/components/ContentSpinner';
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import InputWidget from '../../core/components/complex-table/components/InputWidget';
import ModalFooter from './components/ModalFooter';

extend('required', {
  ...required,
  message: 'The {_field_} field is required.',
});

const {mapState, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'MeasuresModal',
  components: {ModalFooter, InputWidget, ContentSpinner, ValidationObserver, ValidationProvider},
  data() {
    return {
      expand: false,
      form: {
        id: 0,
        name: null,
        notes: null,
        // tags: [],
        minorElement: false,
        includeOnPhysical: true,
        includeOnLogical: true,
        dataType: null,
        numericPrecision: 16,
        numericScale: 8,
        defaultValue: null,
        aggregationType: null,
        uuid: Math.random() * 1000,
      },
      addAnother: false,
      fields: {
        name: {
          type: 'text',
          required: true,
          label: 'Name',
          name: 'name',
        },
        notes: {
          type: 'text',
          required: false,
          label: 'Notes',
          name: 'notes',
        },
        /*tags: {
            type: 'tags',
            required: false,
            label: 'Tags',
            name: 'tags'
          },*/
        minorElement: {
          type: 'checkbox',
          required: false,
          label: 'Minor Element',
          name: 'minorElement',
        },
        includeOnPhysical: {
          type: 'checkbox',
          required: false,
          label: 'Include On Physical Model',
          name: 'includeOnPhysical',
        },
        includeOnLogical: {
          type: 'checkbox',
          required: false,
          label: 'Include On Logical Model',
          name: 'includeOnLogical',
        },
        dataType: {
          type: 'select',
          required: false,
          label: 'Data Type',
          name: 'dataType',
          data: {
            options: ['INT', 'MONEY', 'DECIMAL'],
          },
        },
        numericPrecision: {
          type: 'number',
          required: false,
          label: 'Numeric Precision',
          name: 'numericPrecision',
        },
        numericScale: {
          type: 'number',
          required: false,
          label: 'Numeric Scale',
          name: 'numericScale',
        },
        defaultValue: {
          type: 'number',
          required: false,
          label: 'Default Value',
          name: 'defaultValue',
        },
        aggregationType: {
          type: 'select',
          required: false,
          label: 'Aggregation Type',
          name: 'aggregationType',
          data: {
            options: ['COUNT', 'DISTINCT COUNT', 'SUM', 'MIN', 'MAX', 'AVERAGE'],
          },
        },
      },
    };
  },
  computed: {
    ...mapState(['measuresModal']),
  },
  methods: {
    ...mapActions(['hideMeasuresModal','addReason']),
    beforeHide(e) {
      this.expand = false;
      if (this.measuresModal.loading) {
        e.preventDefault();
        return false;
      }
    },
    async onSubmit(e) {
      // e.preventDefault();
      const {success} = await this.addReason(this.form);
      if (success) {
        if (!this.addAnother) {
          this.hideMeasuresModal();
        }
        this.resetModal();
        this.$refs.focusedField.$refs.currentInput.focus();
      }
    },
    resetModal() {
      this.form = {
        id: 0,
        name: '',
        notes: '',
        // tags: [],
        changeType: '',
        deletionType: '',
        isInternal: false,
        isPlatformGenerated: false,
        uuid: null,
      };
      this.$refs.formObserver.reset();
    },
    onReset() {

    },
  },
};
</script>

<style lang="scss">
  #measuresModal {
    /deep/ .lobi-spinner {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: white;
      z-index: 1;
    }

    .expand-button {
      display: block;
      margin: 0 auto;
    }
  }
</style>